import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface BlogTemplateStyles {
    blog?: InjectableCss;
}

export const BlogTemplateStyles: BlogTemplateStyles = {
    blog: {
        css: css`
            margin-bottom: 30px;
            margin-top: 40px;
            h3 {
                padding-bottom: 20px;
                font-size: 24px;
                color: #666;
            }
            h4 {
                span {
                    color: #3666b1;
                    font-size: 18px;
                }
            }
            [class^="GridOffset"] {
                [class^="GridItemStyle"] {
                    [class^="Wrapper"] {
                        transition: all 0.8s ease 0s;
                        div:first-child {
                            display: flex;
                        }
                        &:hover {
                            box-shadow: 0 1px 6px 1px rgba(133, 133, 133, 0.25);
                        }
                        [class^="LazyImageStyle"] {
                            border: 2px solid #f2f3f5;
                            border-bottom: 0;
                        }
                        [class^="ContentWrapper"] {
                            padding: 10px 15px;
                            border: 2px solid #f2f3f5;
                            border-top: 0;
                            p {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        `,
    },
};

const styles = BlogTemplateStyles;

const BlogTemplate: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.blog} data-test-selector="BlogTemplate">
            <Zone contentId={id} zoneName="blog" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BlogTemplate,
    definition: {
        displayName: "Custom Blog Template",
        group: "Common",
    },
};

export default widgetModule;
